export const formatMillisecondsToHours = (milliseconds: string | number) => {
  var numberValue = 0;

  if (typeof milliseconds === 'number') {
    numberValue = milliseconds;
  } else {
    numberValue = parseInt(milliseconds, 10);
  }

  const date = new Date(numberValue);
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const convertMinutesToDaysMinutes = (
  minutes: number,
): { days: number; minutes: number } => {
  const oneDayMinutes = 1440;

  const days = Math.floor(minutes / oneDayMinutes);
  const mins = Math.floor(minutes % oneDayMinutes);
  return { days: days, minutes: mins };
};

export const formatMilisecondsToMinutes = (miliseconds: number) => {
  return Math.floor(miliseconds / (60 * 1000));
};

export const formatMeterToKilometer = (meter: number) => {
  return (meter / 1000).toFixed(2);
};

export function convertMillisecondsToTimeOfDay(
  timestamp: string | number,
): string {
  let milliseconds: number;

  if (typeof timestamp === 'string') {
    milliseconds = parseInt(timestamp, 10);

    if (isNaN(milliseconds)) {
      console.warn(
        `Warning: Invalid timestamp string "${timestamp}". Returning "00:00:00".`,
      );
      return '00:00'; // Or throw an error, depending on desired error handling
    }
  } else {
    // If it's already a number, use it directly
    milliseconds = timestamp;
  }

  // Ensure the milliseconds value is non-negative
  if (milliseconds < 0) {
    console.warn(`Warning: Negative timestamp ${milliseconds}. Treating as 0.`);
    milliseconds = 0;
  }

  if (milliseconds === 0) {
    return '00:00';
  }

  const date = new Date(milliseconds);

  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  //const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${hours}:${minutes}`; //:${seconds}`;
}

/**
 * Converts hour and minute to timeId format (HHMM as number)
 * Example: toTimeId(14, 30) returns 1430
 */
export const toTimeId = (hour: number, minute: number): number => {
  return hour * 100 + minute;
};

/**
 * Converts milliseconds (time of day) to timeId format (HHMM as number)
 * Example: millisecondsToTimeId(52200000) returns 1430 (14:30)
 */
export const millisecondsToTimeId = (milliseconds: number): number => {
  const totalMinutes = Math.floor(milliseconds / 60000);
  const hour = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;
  return toTimeId(hour, minute);
};
